var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "text-center" }, [
            _c("h1", [_vm._v("404")]),
            _c("h3", [_vm._v("Cette page n'existe pas...")]),
            _c("h3", [
              _c("a", { attrs: { href: "/" } }, [_vm._v("Retour à l'accueil")])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }